import type { Session } from '@supabase/supabase-js';

export type EmbedBridgeSession = {
  access_token: string;
  refresh_token: string;
  expires_at?: number;
};

export type EmbedBridgeEventHandlers = {
  onAuthReady?: (state: { authenticated: boolean; appContainer: boolean }) => void;
  onLoggedOut?: (appContainer: boolean) => void;
  onSessionUpdated?: (state: { session: EmbedBridgeSession; appContainer: boolean }) => void;
};

export const AUTH_BRIDGE_VERSION = 1;

type TransferableSession = Pick<Session, 'access_token' | 'refresh_token' | 'expires_at'>;

export type EmbedBridgeMessage =
  | {
      type: 'kk:auth:ready';
      version: typeof AUTH_BRIDGE_VERSION;
      authenticated: boolean;
      appContainer: boolean;
    }
  | {
      type: 'kk:auth:session';
      version: typeof AUTH_BRIDGE_VERSION;
      session: TransferableSession;
      appContainer: boolean;
    }
  | {
      type: 'kk:auth:session:updated';
      version: typeof AUTH_BRIDGE_VERSION;
      session: TransferableSession;
      appContainer: boolean;
    }
  | {
      type: 'kk:auth:logout';
      version: typeof AUTH_BRIDGE_VERSION;
      appContainer: boolean;
    }
  | {
      type: 'kk:auth:logged-out';
      version: typeof AUTH_BRIDGE_VERSION;
      appContainer: boolean;
    };
